function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_mm_logo)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.9524 0.727295L14.4072 7.79515L16.1822 3.62983L23.9524 0.727295Z",
  fill: "#E17726",
  stroke: "#E17726",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.93506 0.727295L11.3952 7.86111L9.70523 3.62983L1.93506 0.727295Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5153 17.1152L17.9756 20.9979L23.4137 22.4963L24.9716 17.2001L20.5153 17.1152Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.925781 17.2001L2.47414 22.4963L7.90288 20.9979L5.37261 17.1152L0.925781 17.2001Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.60921 10.5563L6.09863 12.8369L11.4801 13.0819L11.3008 7.28625L7.60921 10.5563Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.2776 10.5564L14.5295 7.22034L14.4067 13.082L19.7882 12.8369L18.2776 10.5564Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.90234 20.9978L11.1595 19.4241L8.35554 17.2377L7.90234 20.9978Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.728 19.4241L17.9758 20.9978L17.532 17.2377L14.728 19.4241Z",
  fill: "#E27625",
  stroke: "#E27625",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9758 20.9979L14.728 19.4242L14.9923 21.5351L14.964 22.4304L17.9758 20.9979Z",
  fill: "#D5BFB2",
  stroke: "#D5BFB2",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.90234 20.9979L10.9236 22.4304L10.9047 21.5351L11.1595 19.4242L7.90234 20.9979Z",
  fill: "#D5BFB2",
  stroke: "#D5BFB2",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.98 15.843L8.27979 15.0515L10.1869 14.175L10.98 15.843Z",
  fill: "#233447",
  stroke: "#233447",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9077 15.843L15.7008 14.175L17.6174 15.0515L14.9077 15.843Z",
  fill: "#233447",
  stroke: "#233447",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.90182 20.9979L8.37391 17.1152L5.37158 17.2001L7.90182 20.9979Z",
  fill: "#CC6228",
  stroke: "#CC6228",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5132 17.1152L17.9758 20.9979L20.5155 17.2001L17.5132 17.1152Z",
  fill: "#CC6228",
  stroke: "#CC6228",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.7882 12.8368L14.4067 13.0818L14.9071 15.843L15.7002 14.175L17.6168 15.0514L19.7882 12.8368Z",
  fill: "#CC6228",
  stroke: "#CC6228",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.27956 15.0514L10.1867 14.175L10.9798 15.843L11.4801 13.0818L6.09863 12.8368L8.27956 15.0514Z",
  fill: "#CC6228",
  stroke: "#CC6228",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.09912 12.8368L8.3556 17.2377L8.28001 15.0514L6.09912 12.8368Z",
  fill: "#E27525",
  stroke: "#E27525",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6172 15.0514L17.5322 17.2377L19.7887 12.8368L17.6172 15.0514Z",
  fill: "#E27525",
  stroke: "#E27525",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.4808 13.0818L10.98 15.843L11.613 19.1036L11.7547 14.8064L11.4808 13.0818Z",
  fill: "#E27525",
  stroke: "#E27525",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.4072 13.0818L14.1426 14.797L14.2749 19.1036L14.9079 15.843L14.4072 13.0818Z",
  fill: "#E27525",
  stroke: "#E27525",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9075 15.8431L14.2749 19.1037L14.7281 19.4242L17.5322 17.2378L17.6171 15.0515L14.9075 15.8431Z",
  fill: "#F5841F",
  stroke: "#F5841F",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.27979 15.0515L8.35537 17.2378L11.1594 19.4242L11.6126 19.1037L10.98 15.8431L8.27979 15.0515Z",
  fill: "#F5841F",
  stroke: "#F5841F",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9644 22.4303L14.9927 21.535L14.7473 21.3277H11.1407L10.9047 21.535L10.9236 22.4303L7.90234 20.9979L8.95976 21.8648L11.1029 23.3444H14.7755L16.9281 21.8648L17.9761 20.9979L14.9644 22.4303Z",
  fill: "#C0AC9D",
  stroke: "#C0AC9D",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.728 19.4241L14.2748 19.1037H11.6124L11.1592 19.4241L10.9043 21.535L11.1403 21.3277H14.7469L14.9924 21.535L14.728 19.4241Z",
  fill: "#161616",
  stroke: "#585858",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.358 8.25689L25.1606 4.35546L23.9521 0.727295L14.728 7.55959L18.2779 10.5563L23.2912 12.017L24.3958 10.726L23.9144 10.3773L24.679 9.67995L24.0937 9.22758L24.8585 8.64329L24.358 8.25689Z",
  fill: "#763E1A",
  stroke: "#763E1A",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.727051 4.35546L1.539 8.25689L1.01973 8.64329L1.79391 9.22758L1.20856 9.67995L1.97329 10.3773L1.49179 10.726L2.59642 12.017L7.60975 10.5563L11.1596 7.55959L1.93553 0.727295L0.727051 4.35546Z",
  fill: "#763E1A",
  stroke: "#763E1A",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.2914 12.0169L18.2781 10.5563L19.7887 12.8369L17.5322 17.2377L20.5157 17.2001H24.9719L23.2914 12.0169Z",
  fill: "#F5841F",
  stroke: "#F5841F",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.61015 10.5563L2.59688 12.0169L0.925781 17.2001H5.37261L8.35601 17.2377L6.09958 12.8369L7.61015 10.5563Z",
  fill: "#F5841F",
  stroke: "#F5841F",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.4068 13.0819L14.7278 7.55952L16.1817 3.62982H9.70508L11.159 7.55952L11.48 13.0819L11.6028 14.8159L11.6122 19.1037H14.2746L14.2841 14.8159L14.4068 13.0819Z",
  fill: "#F5841F",
  stroke: "#F5841F",
  strokeWidth: 0.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_mm_logo"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 24,
  fill: "white"
})));

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.fad83f04.svg";
export { ForwardRef as ReactComponent };